// src/components/companies/companiesList/newCompaniesList/companiesTable/index.tsx

import { memo } from "react";

import { Flex } from "@chakra-ui/react";

import CompanyInfoTable from "./companyInfoTable";

const CompaniesTable = ({ companies }) => {
  return (
    <Flex direction={"column"} ps={"20px"}>
      <CompanyInfoTable companies={companies} />
    </Flex>
  );
};

export default memo(CompaniesTable);